import React from "react";
import withView from '../../../cmn/docAutomation/withView';
import DashViewRow from './DashViewRow';

const DashView = (props) => {
    const { formObject, viewData, onClick, filterDate, deviceInfo, selectedRow } = props;

    if(!viewData)
        return(null)

    const data = formObject.getFormRow("","DashViews");

    return (
        <div className={`${deviceInfo.activateMobileView ? 'uiSelectedChipTrans' : 'uiViewDashBoardActivator'} `}>
            <ul className="uiFlexBox">
                {
                    Object.values(data.rowValues).map((childRow, index) => (
                        <DashViewRow selectedRow={selectedRow} formObject={formObject} rowKey={childRow.key} viewData={childRow} key={index} 
                            onClick={onClick} filterDate={filterDate} 
                        />
                    ))
                }
            </ul>
        </div>
    )
}

export default withView(DashView, "dashViews", "")
